export enum TiersType {
	None = 'none',
	PersonnePhysique = 'personnePhysique',
	PersonneMorale = 'personneMorale'
}

export enum TiersPartie {
	Partie1 = 'partie1',
	Partie2 = 'partie2'
}

export enum ControlFieldIdAffaireEnum {
	AffairePartie1ControlId = 'field-partie1',
	AffairePartie2ControlId = 'field-partie2'
}

export enum QualiteTiersComportement {
	Aucun = 'aucun',
	ClientVendeur = 'clientVendeur',
	AdversaireAcquereur = 'adversaireAcquereur',
	AvocatAdverse = 'avocatAdverse',
	Honoraires = 'honoraires',
	Remboursement = 'remboursement',
	TresorPublic = 'tresorPublic',

}

export enum QualiteTiersJustificationDebit {
	None = 'none',
	MotifReglement = 'motifReglement',
	AutorisePar = 'autorisePar'
}

export enum QualiteTiersJustificationCredit {
	None = 'none',
	LienEmetteur = 'lienEmetteur'
}

export enum QualiteTiersCode {
	Honoraires = 'HON',
	Huissiers = 'HJ',
	RemboursementFrais = 'REM',
	FraisDebours = 'FDE',
	AvocatPrelev = 'AVO'
}

export enum TiersSortableCols {
	Nom = 'Nom',
	Prenom = 'Prenom'
}

export enum TypeImmatriculation {
	Siren = 'siren',
	RegistreEquivalent = 'registreEquivalent',
	Imo = 'imo',
}
